import styled from 'styled-components';
import { EyeOutline } from '@styled-icons/evaicons-outline/EyeOutline';
import { EyeOffOutline } from '@styled-icons/evaicons-outline/EyeOffOutline';

export const EyeIcon = styled(EyeOutline)`
  width: 1.5rem;
  margin-right: 0.5rem;
`;

export const EyeOffIcon = styled(EyeOffOutline)`
  width: 1.5rem;
  margin-right: 0.5rem;
`;

export const ContainerInput = styled('div')<{ error: boolean }>`
  margin-bottom: ${(props) => (props.error ? '1.5rem' : '0.5rem')};
  margin-top: 0.5rem;
`;

export const ContainerLink = styled('div')`
  margin-top: 1rem;
`;

export const ExternalLink = styled.a`
  text-decoration: underline;
  color: ${({ theme }) => theme.colors.blue6};
  weight: 600;
  font-size: 1rem;
`;
